<app-store-navigation></app-store-navigation>
@if (predictionWeek) {
  <div>
    <div class="row m-2">
      <div class="me-auto col-3">
        <app-rota-page-switch [weekId]="predictionWeek.id" [isActiveRotaPage]="false"></app-rota-page-switch>
      </div>
      <div class="d-inline-block text-center col-6">
        <a [ngClass]="{'link-disabled': !previousPredictionWeek}"
          routerLink="/footfall-week/{{previousPredictionWeek?.id}}"
        class="btn btn-primary btn-sm me-2"><</a>
        <div class="week-with-date">
          <span class="week-number">Week {{predictionWeek.from | dateParse | dateFormat: 'WW'}}</span>
          <span class="week-start">{{predictionWeek.from | dateParse | dateFormat: 'ddd, D MMM YYYY'}}</span> -
          <span class="week-end">{{predictionWeek.to | dateParse | dateFormat: 'ddd, D MMM YYYY'}}</span>
        </div>
        <a [ngClass]="{'link-disabled': !nextPredictionWeek}"
          routerLink="/footfall-week/{{nextPredictionWeek?.id}}"
        class="btn btn-primary btn-sm ms-2">></a>
      </div>
      <div class="mt-1 text-end col-3">
        @for (weekday of weekdays; track weekday; let i = $index) {
          <a (click)="scroll('week-' + i)" class="weekday-link">
            {{ weekday | dayOfWeekParse }}
          </a>
        }
      </div>
    </div>
    <div>
      <div class="pt-2 pb-2 shadow-sm p-3 mb-5 bg-light rounded">
        <app-footfall-week-totals [dailyPredictions]="predictionWeek.dailyPredictions"></app-footfall-week-totals>
      </div>
      @for (dailyPrediction of predictionWeek.dailyPredictions; track dailyPrediction; let i = $index) {
        <div id="week-{{i}}">
          <div class="pt-2 pb-2 shadow-sm p-3 mb-5 bg-light rounded">
            <app-footfall-week-chart class="app-footfall-week-chart-{{i}}"
            [dailyPrediction]="dailyPrediction"></app-footfall-week-chart>
          </div>
        </div>
      }
    </div>
  </div>
}
